export const UI_SHOW_EXIT_POPUP = 'UI_SHOW_EXIT_POPUP';
export const UI_HIDE_EXIT_POPUP = 'UI_HIDE_EXIT_POPUP';
export const UI_CHANGE_CURRENT_STEP = 'UI_CHANGE_CURRENT_STEP';
export const UI_TOGGLE_OLX_PRO_POPUP = 'UI_TOGGLE_OLX_PRO_POPUP';
export const UI_TOGGLE_LOADING = 'UI_TOGGLE_LOADING';
export const UI_SELECTED_CHARACTERISTIC = 'SELECTED_CHARACTERISTIC';
export const UI_SHOW_MODAL = 'UI_SHOW_MODAL';
export const UI_HIDE_MODAL = 'UI_HIDE_MODAL';

export default {
  UI_SHOW_EXIT_POPUP,
  UI_HIDE_EXIT_POPUP,
  UI_CHANGE_CURRENT_STEP,
  UI_TOGGLE_OLX_PRO_POPUP,
  UI_TOGGLE_LOADING,
  UI_SELECTED_CHARACTERISTIC,
  UI_SHOW_MODAL,
  UI_HIDE_MODAL,
};
